import { create } from "zustand";

export enum ReactionActionState {
    IDLE,
    LOADING,
}

interface ReactionActionSlice {
    reactionActionState: ReactionActionState;
    setReactionActionState: (value: ReactionActionState) => void;
}

export const useReactionActionStore = create<ReactionActionSlice>()((set) => ({
    reactionActionState: ReactionActionState.IDLE,
    setReactionActionState: (newValue: ReactionActionState) =>
        set(() => ({ reactionActionState: newValue })),
}));
